'use client';
import React, { useCallback, useState, useTransition } from 'react';
import { useTranslations } from 'next-intl';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { CatSideMenu, CatSideMenuItem } from 'components/blocks-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { SideMenuList, SidePanelProps } from '../../types';
import { CustomerAccountLoading } from '../../loading';
import styles from '../../customer-account.module.scss';

export const SidePanel = ({
  searchParam,
  mobile,
  children,
  sideMenuList
}: Readonly<SidePanelProps>) => {
  const t = useTranslations();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [menuItem, setMenuItem] = useState('');
  const [loading, startTransition] = useTransition();

  const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const onSideMenuChange = useCallback(
    (name: string, value: string) => {
      setMenuItem(value);
      startTransition(() => {
        const params = new URLSearchParams(searchParams.toString());
        if (value === sideMenuList.my_eqp.name) {
          params.delete(name);
        } else {
          params.set(name, value);
        }
        router.push(`${pathname}?${params.toString()}`, { scroll: false });
      });
    },
    [pathname, router, searchParams, sideMenuList.my_eqp.name]
  );

  return (
    <>
      <Conditional test={isLG === true}>
        <div

          className={`${styles['customer-account-wrapper--tabs-wrapper']}`}

        >
          <CatSideMenu
            className={styles['customer-account__side-menu--no-border']}
          >
            {Object.values(sideMenuList)
              .filter((value: SideMenuList) => !value?.isHide)
              .map((menu) => {
                return (
                  <CatSideMenuItem
                    key={menu.name}
                    isCurrent={searchParam === menu.name}
                    onClick={() => onSideMenuChange('menu', menu.name)}
                    data-track-event={menu.ga_event_name}
                    data-track-attr-nltext={menu.ga_nltext}
                    data-track-attr-context={menu.ga_context}
                  >
                    {t(menu.label)}
                  </CatSideMenuItem>
                );
              })}
          </CatSideMenu>
        </div>
        <div
          className={`position-relative ${styles['customer-account--content-wrapper']}`}
        >
          <Conditional
            test={!loading}
            fallback={<CustomerAccountLoading menu={menuItem} />}
          >
            {children}
          </Conditional>
        </div>
      </Conditional>
      <Conditional test={isLG === false}>{mobile}</Conditional>
    </>
  );
};
